import { createI18nText } from '@hilma/netina2all';

const personalDetailsRulesText = createI18nText({
	he: {
		fullName: 'השם המלא',
		address: 'כתובת'
	},
	en: {
		fullName: 'full name',
		address: 'address'
	}
});

export default personalDetailsRulesText;